import { IResponse } from "models";

export enum ActionType {
  // download PDF file TypeInfo list
  FULL_STRESS_TYPE_DOWNLOAD_CSV = "action/FULL_STRESS_TYPE_DOWNLOAD_CSV",
  FULL_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS = "action/FULL_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS",
  FULL_STRESS_TYPE_DOWNLOAD_CSV_ERROR = "action/FULL_STRESS_TYPE_DOWNLOAD_CSV_ERROR",
  FULL_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA = "action/FULL_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface FullStressTypeCSVDownloadResponse extends IResponse {
  result?: ICSVDownloadResult;
}

export interface ICSVDownloadResult {
  data: ICSVDownloadFullStressTypeItem[];
  headers: IHeaderCSVDownloadFullStressTypeItem[];
}
export interface IFullStressTypeDownloadCsvData {
  not_implement: boolean;
  start_date?: string;
  end_date?: string;
  interview_request_sent: boolean;
  need_attention: boolean;
  high_stress_1: boolean;
  high_stress_2: boolean;
  interview_request_not_sent: boolean;
}

export interface IHeaderCSVDownloadFullStressTypeItem {
  label: string;
  key: string;
}

export interface ICSVDownloadFullStressTypeItem {
  name: string;
  date_of_implementation: string;
  stress_situation: string;
  status: string;
  interview_transmission_status: string;
  B: string;
  A_C: string;
  affiliation: string;
  gender: string;
}
